var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<header><header-primary><header-games></header-games></header-primary></header><div class=\"o-wrapper\"><gg-tabs><gg-tab name=\"settings\" label=\"{{ 'settings' | translateWith:'app' }}\"><div class=\"c-panel\"><div ng-form=\"vm.form\" novalidate=\"\" class=\"form layout\"><games-form resource=\"vm.game\" logo=\"vm.logo\"></games-form></div></div><div class=\"layout layout--right layout--auto\"><div class=\"layout__item\"><a id=\"game-update-btn\" ng-click=\"!(vm.form.$invalid || vm.isResourceBeingPersisted) &amp;&amp; vm.update()\" ng-class=\"{'is-disabled': vm.form.$invalid || vm.isResourceBeingPersisted}\" rp-except=\"GG_ACCOUNT_MANAGER,AGENCY\" class=\"o-btn c-btn c-btn--primary\">{{ {create: vm.new, update:!vm.new} | translateWith:'app' }}</a></div></div></gg-tab></gg-tabs></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/analytics/analyticsEdit.jade
 ** module id = 659
 ** module chunks = 0
 **/